import { render, staticRenderFns } from "./FinanceTabTurnover.vue?vue&type=template&id=229b7494&scoped=true"
import script from "./FinanceTabTurnover.vue?vue&type=script&lang=js"
export * from "./FinanceTabTurnover.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabTurnover.vue?vue&type=style&index=0&id=229b7494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b7494",
  null
  
)

export default component.exports